var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTooltipArrow = function SvgTooltipArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tooltip-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.414 17.414 8 24V8l-6.586 6.586a2 2 0 0 0 0 2.828Z",
    fill: "#142138"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tooltip-arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 4 4)",
    d: "M0 0h32v8H0z"
  })))));
};
export { SvgTooltipArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDggMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF85Mzg6MTM1NTkpIj4KPHBhdGggZD0iTTEuNDE0MjEgMTcuNDE0Mkw4IDI0TDggOEwxLjQxNDIxIDE0LjU4NThDMC42MzMxNjUgMTUuMzY2OCAwLjYzMzE2NCAxNi42MzMyIDEuNDE0MjEgMTcuNDE0MloiIGZpbGw9IiMxNDIxMzgiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85Mzg6MTM1NTkiPgo8cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iOCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgpIHJvdGF0ZSg5MCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";